// const BaseURL = `http://localhost:4242`;
// export const BaseURL = `https://apisystem.skill-code.com`;
// export const BaseURL = `http://127.0.0.1:3000`;
export const BaseURL = `https://apistaging.skill-code.com`;
// Auth URLs
export const loginURL = `${BaseURL}/dashboard/auth/login`;
export const logoutURL = `${BaseURL}/dashboard/auth/logout`;
export const userInfo = `${BaseURL}/dashboard/auth/loggedInInfo`;

// Activation URLs
export const activateURL = `${BaseURL}/activate`;
export const changePasswordURL = `${BaseURL}/dashboard/profile/changePassword`;

// School URLs
export const schoolURL = `${BaseURL}/dashboard/schools`;
export const schoolListURL = `${BaseURL}/dashboard/schools/list`;

// Teacher URLs
export const teacherURL = `${BaseURL}/dashboard/teachers`;
export const teacherListURL = `${BaseURL}/dashboard/teachers/list`;

// Student URLs
export const studentURL = `${BaseURL}/dashboard/students`;

// Course URLs
export const courseURL = `${BaseURL}/dashboard/courses`;
export const courseListURL = `${BaseURL}/dashboard/courses/list`;

// Class URLs
export const classesURL = `${BaseURL}/dashboard/classes`;

// Lesson URLs
export const lessonURL = `${BaseURL}/dashboard/lessons`;

// Country URLs
export const countriesURL = `${BaseURL}/dashboard/countries`;

// Dashboard URLs
export const dashboardURL = `${BaseURL}/dashboard/home`;
export const profileURL = `${BaseURL}/dashboard/profile`;
export const reportsURL = (id) => `${BaseURL}/dashboard/classes/${id}/reports`;
export const sessionsClassesURL = (id) =>
  `${BaseURL}/dashboard/classes/${id}/sessions`;
export const reportsClassesURL = (id) =>
  `${BaseURL}/dashboard/classes/${id}/reports`;

// AI URLs (backend proxy — no Google key in frontend)
export const generateAiContentURL = `${BaseURL}/dashboard/ai/generate-content`;
export const generateAiFeedbackURL = `${BaseURL}/dashboard/ai/generate-feedback`;
